import React from "react";
import { TFuncKey } from "react-i18next";
import { Assignment, ListAlt } from "@material-ui/icons";
import { Area } from "types";
import { isContentOnly } from "utils/appMode";
import HealthForms from "routes/healthForms/HealthForms";
import { TemplateRoutes } from "routes/createContent/views/templates/TemplateRoutes";

type ContentFeature = {
  area: Area;
  label: TFuncKey;
  Icon: React.ComponentType;
  render: () => React.ReactNode;
  hidden?: boolean;
};

export const contentFeatures: ContentFeature[] = [
  {
    area: Area.HealthForms,
    label: "views.health_forms",
    Icon: Assignment,
    render: () => <HealthForms />,
  },
  {
    area: Area.CreateContent_Templates,
    label: "views.treatment_templates",
    Icon: ListAlt,
    render: () => <TemplateRoutes />,
    hidden: true,
  },
];

const contentAreas: string[] = contentFeatures.map(feature => feature.area);

export const navVisible = (area: string) =>
  isContentOnly ? contentAreas.includes(area) : !contentAreas.includes(area);
